import { get } from 'lodash';
/**
 * Set a variant name, inside `variant` property.
 * Return the variant key alone if value is `null`, which will return the `__default` of the variant.
 *
 * @param  {string} key
 * @param  {srting} value
 *
 * @example setVariantString('button', null)
 * @returns {string} 'button'
 *
 * @example setVariantString('button', variant)
 * @returns {string} 'button.primary'
 *
 * @example setVariantString('button.sizes', size)
 * @returns {string} 'button.sizes.large'
 */

var setVariantString = function setVariantString(key, value) {
  if (value != null) return key + '.' + value;
  return key;
};
/**
 * Spread variant inside the sx prop
 *
 * @param  {Object} obj The source style object
 * @param  {Array.<string>} path Path to the variant
 * @param  {Array.<string>} props.value Variant key
 * @param  {Array.<string>} props.key Fallback key
 * @param  {Array.<string>} props.styles Is a style object
 *
 * @returns {Object} Style Object
 */


var spreadVariant = function spreadVariant(obj, path, _ref) {
  var key = _ref.key,
      value = _ref.value,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? false : _ref$styles;

  var __default = get(obj, setVariantString(path, value || key || '__default'));

  if (styles) return get(obj, path);
  return get(obj, setVariantString(value ? path : __default == null ? void 0 : __default.variant, value));
};

export { setVariantString, spreadVariant };